import { useEffect, useRef, useState } from "react";
import classes from './DynamicMessage.module.css'
import { useSelector } from 'react-redux';
import restore from '../../../assests/restore.png'
import { onKeyDown } from "../../../service";
import { DynamicMessageTypeEnum } from "../../../models/DynamicMessageTypeEnum";

const DynamicMessage = ({ type, headerText, title, content, cancelText, cancelFunc, confirmText, confirmFunc, otherText, otherFunc, showCancel = true, showRestore, customWidth }) => {

    const [message, setMessage] = useState(null)

    const texts = useSelector(state => state.translate.texts);

    const mref = useRef(null)

    const typeName = Object.keys(DynamicMessageTypeEnum).find(key => DynamicMessageTypeEnum[key] === type);

    useEffect(() => {
        setTimeout(() => {
            if (mref.current)
                mref.current.style.transform = 'translate(0, 0)';
        }, 1)
    }, [type, title])

    useEffect(() => {
        setMessage(
            <div className={classes.Backdrop}>
                <div className={classes.MessagePopupContainer} ref={mref} style={{ width: customWidth }}>
                    <div className={`${classes.Header} ${classes[typeName]}`}>
                        <div className={classes.Icon}> </div>
                        <p>{headerText || texts[typeName]}</p>
                    </div>
                    <div className={classes.MessageText}>
                        <div className={classes.MessageTitle}>{title}</div>
                        <div className={classes.MessageContent}>{content}</div>
                        {showRestore &&
                            <div className={classes.RestoreChild}>
                                <img src={restore} alt='restore' />
                                <div className={classes.RestoreText}>{texts.restoreRecommended} </div>
                            </div>}
                    </div>
                    {type !== DynamicMessageTypeEnum.NoEnter &&
                        <div className={`${classes.BtnsContainer} ${(type === DynamicMessageTypeEnum.Error || !showCancel) ? classes.BtnsContainerError : ''}`}>
                            {type !== DynamicMessageTypeEnum.Error && showCancel && <div className={`${classes.Btn} ${classes.BtnCancel}`} onClick={clickCancel} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickCancel)}>{cancelText || texts.cancel}</div>}
                            {otherText && <div className={`${classes.Btn} ${classes.BtnCancel}`} onClick={clickOther} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickOther)}>{otherText}</div>}
                            <div className={`${classes.Btn} ${classes.BtnOk}`} onClick={clickConfirm} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickConfirm)}>{confirmText || texts.ok}</div>
                        </div>}
                </div>
            </div>)
    }, [type, title])

    const clickCancel = () => {
        setMessage(null);
        cancelFunc && cancelFunc();
    }

    const clickConfirm = (e) => {
        confirmFunc(e);
        setMessage(null);
    }

    const clickOther = () => {
        setMessage(null);
        otherFunc && otherFunc();
    }

    return (
        <>{message}</>
    )
}

export default DynamicMessage;